import styled from 'styled-components';

import { ModalBody, Input, Button } from 'reactstrap';
import { color } from '../../../assets/styles/colors';

export const Title = styled.h1`
	background-color: #D3FBE1;
	font-size: 18px;
	font-weight: bold;
	padding: 11px 0 11px 4vw;
	overflow: auto;
	border-bottom: 1px solid black;
`;

export const DivCss = styled.div`
	display: table-row;
	vertical-align: inherit;
`;

export const Th = styled.div`
	font-size: 16px;
	font-weight: 400;
	display: table-cell;
	vertical-align: inherit;
	padding: 0 8px 18px 0;
`;

export const Td = styled.div`
	font-size: 16px;
	font-weight: 300;
	color: #00578d;
	display: table-cell;
	vertical-align: inherit;
	padding: 0 0 18px 0;
`;

export const TextoSaldo = styled.h5`
	font-size: 18px;
	font-weight: 400;
	color: #929292;
	padding: 0 0 5px 0;
`;

export const ValoresSaldo = styled.h5`
	font-size: 16px;
	font-weight: 700;
	padding: 0 0 0 30px;
`;

export const ModalBodyCss = styled(ModalBody)`
	align-items: center;
	justify-content: space-between;
	padding: 30px 4vw 40px 4vw;
`;

export const ModalFooterCss = styled.div`
	background-color: #D3FBE1;
	border-top: 1px solid black;
	text-align: right;
	width: 100%;
	overflow: auto;
	padding: 0px 4vw 0 0;
`;

export const ButtonCss = styled(Button)`
	font-size: 14px;
	min-height: 30px;
	font-weight: 500;
	background-color: ${color.yellow};
`;

export const InputCss = styled(Input)`
	min-height: 280px;
	font-size: 16px;
	font-weight: 300;
	line-height: 160%;

	@media (max-width: 768px) {
    	min-height: 100px;
  	}
`;
